webpackJsonptesseract([12],{

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AboutOurAds", function() { return AboutOurAds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CcpaData", function() { return CcpaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CcpaMain", function() { return CcpaMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CcpaPartners", function() { return CcpaPartners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gdpr", function() { return Gdpr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrivacyPolicy", function() { return PrivacyPolicy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ccpa_data__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ccpa_main__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ccpa_partners__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_about_our_ads__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_gdpr__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_privacy_policy__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl_json__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__intl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_preact_i18n__ = __webpack_require__(9);









function intlWrap(component) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_preact_i18n__["e" /* default */])(component, { scope: 'privacy-widgets', definition: __WEBPACK_IMPORTED_MODULE_6__intl_json___default.a });
}

var AboutOurAds = intlWrap(__WEBPACK_IMPORTED_MODULE_3__components_about_our_ads__["a" /* AboutOurAds */]);
var CcpaData = intlWrap(__WEBPACK_IMPORTED_MODULE_0__components_ccpa_data__["a" /* CcpaData */]);
var CcpaMain = intlWrap(__WEBPACK_IMPORTED_MODULE_1__components_ccpa_main__["a" /* CcpaMain */]);
var CcpaPartners = intlWrap(__WEBPACK_IMPORTED_MODULE_2__components_ccpa_partners__["a" /* CcpaPartners */]);
var Gdpr = intlWrap(__WEBPACK_IMPORTED_MODULE_4__components_gdpr__["a" /* Gdpr */]);
var PrivacyPolicy = intlWrap(__WEBPACK_IMPORTED_MODULE_5__components_privacy_policy__["a" /* PrivacyPolicy */]);

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_default_config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preconf__ = __webpack_require__(32);
/* unused harmony reexport defaults */



var configure = Object(__WEBPACK_IMPORTED_MODULE_1_preconf__["a" /* default */])(null, __WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default.a);


/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_logo__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_logo__["a"]; });



/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CcpaButtons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_call_with__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__os_call_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__os_call_with__);
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CcpaButtons = function (_Component) {
	_inherits(CcpaButtons, _Component);

	function CcpaButtons() {
		var _temp, _this, _ret;

		_classCallCheck(this, CcpaButtons);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.buttonClicked = function (link) {
			if (link.external) {
				window.open(link.url, '_blank', 'noopener');
			} else {
				window.location.href = link.url;
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CcpaButtons.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var links = _ref.links;

		_objectDestructuringEmpty(_ref2);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.buttons },
			links && links.map(function (link) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.buttonWrapper },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["a" /* Button */],
						{
							'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.button,
							type: 'primary',
							brand: 'primary',
							onClick: __WEBPACK_IMPORTED_MODULE_3__os_call_with___default()(_this2.buttonClicked, link)
						},
						link.text
					)
				);
			})
		);
	};

	return CcpaButtons;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Logo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_performance__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_track__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dlv__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var heroTrackingVars = {
	'data-tracking-type': 'trackgif,appMeasurement',
	'data-tracking-zone': 'logo',
	'data-tracking-svalues-prop66': 'logo'
};

/**
 * This wrapper places a div and an optional a tag if an href is supplied.
 */
function LogoWrapper(_ref) {
	var children = _ref.children,
	    trackingVars = _ref.trackingVars,
	    href = _ref.href,
	    props = _objectWithoutProperties(_ref, ['children', 'trackingVars', 'href']);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style___default.a.logo, props.class) },
		href ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'a',
			_extends({
				'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.link
			}, trackingVars, {
				href: href
			}),
			children
		) : children
	);
}

var Logo = function (_Component) {
	_inherits(Logo, _Component);

	function Logo() {
		var _temp, _this, _ret;

		_classCallCheck(this, Logo);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getTrackingVars = function () {
			if (__WEBPACK_IMPORTED_MODULE_6_dlv___default()(_this.context, 'track.api.isUsingGenericAnalytics', false)) {
				var _extends2;

				return Object(__WEBPACK_IMPORTED_MODULE_5__cube_track__["e" /* createGenericTags */])(_extends((_extends2 = {}, _extends2[__WEBPACK_IMPORTED_MODULE_5__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'LogoWidget', _extends2), __WEBPACK_IMPORTED_MODULE_6_dlv___default()(_this, 'context.trackingVars', {})), Object(__WEBPACK_IMPORTED_MODULE_5__cube_track__["h" /* getProcessEventArgs */])(_this.context));
			}
			return heroTrackingVars;
		}, _this.getLogo = function (baseUrl, theme, size, client) {
			if (!size || !client) return '';
			return baseUrl + '/images/' + client + '/logos/' + theme + '_' + size + '.png';
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Logo.prototype.render = function render(_ref2) {
		var theme = _ref2.theme,
		    size = _ref2.size,
		    clientOverride = _ref2.clientOverride,
		    streamClient = _ref2.streamClient,
		    baseUrl = _ref2.baseUrl,
		    link = _ref2.link,
		    onImageLoad = _ref2.onImageLoad,
		    suppressLink = _ref2.suppressLink,
		    props = _objectWithoutProperties(_ref2, ['theme', 'size', 'clientOverride', 'streamClient', 'baseUrl', 'link', 'onImageLoad', 'suppressLink']);

		// In order to allow a custom image, logo can be either a key into predefined logos, or a URL to a logo image.
		var logoSrc = this.getLogo(baseUrl, theme || 'light', size, clientOverride || streamClient);

		if (logoSrc === '') {
			return;
		}

		Object(__WEBPACK_IMPORTED_MODULE_4__cube_performance__["onImageLoadCallback"])(logoSrc, onImageLoad);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			LogoWrapper,
			{
				'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(props.class),
				href: link,
				trackingVars: this.getTrackingVars(),
				suppressLink: suppressLink
			},
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.spacer }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: logoSrc })
		);
	};

	return Logo;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* configure */])({
	baseUrl: 'logoConfig.baseUrl',
	clientOverride: 'logoConfig.clientOverride',
	streamClient: 'streamClient',
	link: 'logoConfig.link'
})(Logo));

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_default_config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preconf__ = __webpack_require__(32);
/* unused harmony reexport defaults */



var configure = Object(__WEBPACK_IMPORTED_MODULE_1_preconf__["a" /* default */])('logoConfig', __WEBPACK_IMPORTED_MODULE_0__config_default_config_json___default.a);


/***/ }),

/***/ 439:
/***/ (function(module, exports) {

module.exports = {"baseUrl":"https://portal-static.static-origin.syn-cdn.com","link":"/"}

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo_x_x","spacer":"logo_x_spacer"};

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CcpaDataWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CcpaData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__os_call_with__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__os_call_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__os_call_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_synaff__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cube_track__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// list of personal cookies
// format of each entry is name, description, value formatter function
// missing value formatter will simply output the value
var PERSONAL_COOKIES = [['temporalchip', 'Unique ID based on base64 encoding of IP address and timestamp. Used as an identifier for a specific session', function (v) {
	return { rawValue: v, decodedValue: atob(decodeURIComponent(v)) };
}], ['eternalchip', 'Unique ID based on base64 encoding of IP address and timestamp. Used as an identifier for a specific visitor across multiple visits', function (v) {
	return { rawValue: v, decodedValue: atob(decodeURIComponent(v)) };
}], ['synaff', 'Bitmap encoding of categories (e.g. sports, entertainment) that a user has interacted with to use for personalization', function (v) {
	return { rawValue: v, decodedValue: new __WEBPACK_IMPORTED_MODULE_7__cube_synaff__["a" /* default */]().readAndLabel() };
}], ['session', 'Session ID']];

function safeJSONParse(v) {
	try {
		return JSON.parse(v);
	} catch (e) {
		return v;
	}
}

// list of personal local storage entries
// format of each entry is name, description, value formatter function
// missing value formatter will simply output the value
var PERSONAL_LOCAL_STORAGE = [
//weather widget and anything else that uses location
['location-model', 'Location preferences', safeJSONParse],
//finance widget
['finance-components.stock-recently-viewed', 'Recently Viewed Stock Quotes', safeJSONParse], ['sync-user-preferences', 'General User preferences', safeJSONParse], ['notifications', 'Information about browser notifications you have seen', safeJSONParse], ['alerts.dismissed', 'Information on browser based alerts you have dismissed', safeJSONParse], ['@cube/video-hero.gen4_tvmovies', 'Information about videos you have been served and/or watched', safeJSONParse]];

var DELETING_DATA = 2;
var DELETED_DATA = 3;
var DELETE_FAILED = 4;
var HAS_DATA = 5;

var STATUS_TO_TEXT_ID = ['statusChecking', 'statusNoData', 'statusDeleting', 'statusDeleted', 'statusFailed'];

var TYPE_COOKIE = 1;
var TYPE_LOCALSTORAGE = 2;

var CcpaDataWidget = function (_Component) {
	_inherits(CcpaDataWidget, _Component);

	function CcpaDataWidget() {
		var _temp, _this, _ret;

		_classCallCheck(this, CcpaDataWidget);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateStatus = function (name, status) {
			var userData = _extends({}, _this.state.userData);
			userData[name].status = status;
			_this.setState({ userData: userData });
		}, _this.deleteData = function (name) {
			var _trackEvent;

			Object(__WEBPACK_IMPORTED_MODULE_10__cube_track__["k" /* trackEvent */])(_this.context, (_trackEvent = {}, _trackEvent[__WEBPACK_IMPORTED_MODULE_10__cube_track__["a" /* INPUT_KEYS */].action] = 'click', _trackEvent[__WEBPACK_IMPORTED_MODULE_10__cube_track__["a" /* INPUT_KEYS */].priority] = 'high', _trackEvent[__WEBPACK_IMPORTED_MODULE_10__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'CcpaData.Delete', _trackEvent[__WEBPACK_IMPORTED_MODULE_10__cube_track__["b" /* STANDARD_KEYS */].contenttext] = name, _trackEvent));

			if (_this.state.userData[name].type === TYPE_COOKIE) {
				document.cookie = name + '=;max-age=0'; //delete the cookie
				_this.updateStatus(name, DELETED_DATA);
				return;
			} else if (_this.state.userData[name].type === TYPE_LOCALSTORAGE) {
				localStorage.removeItem(name);
				_this.updateStatus(name, DELETED_DATA);
				return;
			}

			_this.updateStatus(name, DELETING_DATA);
		}, _this.getJustData = function (content) {
			return __WEBPACK_IMPORTED_MODULE_8_dlv___default()(content, 'result', 'No Data');
		}, _this.getDownloadData = function () {
			var rows = [['Name', 'Source', 'Description', 'Value']].concat(Object.keys(_this.state.userData).reduce(function (acc, k) {
				var obj = _this.state.userData[k];
				//ignore deleted fields for the download
				if (obj.status === HAS_DATA) {
					acc.push([obj.name || k, obj.source, obj.description, JSON.stringify(obj.value)]);
				}
				return acc;
			}, []));

			var csvContent = 'data:text/tsv;charset=utf-8,' + rows.map(function (e) {
				return e.join('\t');
			}).join('\n');

			return encodeURI(csvContent);
		}, _this.getStatus = function (type) {
			var status = _this.state.userData[type].status;
			return status === HAS_DATA ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["a" /* Button */],
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.delete, type: 'primary', brand: 'primary', onClick: __WEBPACK_IMPORTED_MODULE_6__os_call_with___default()(_this.deleteData, type) },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'statusDeleteButton' })
			) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: STATUS_TO_TEXT_ID[_this.state.userData[type].status] });
		}, _this.onDownloadClick = function () {
			var _trackEvent2;

			Object(__WEBPACK_IMPORTED_MODULE_10__cube_track__["k" /* trackEvent */])(_this.context, (_trackEvent2 = {}, _trackEvent2[__WEBPACK_IMPORTED_MODULE_10__cube_track__["a" /* INPUT_KEYS */].action] = 'click', _trackEvent2[__WEBPACK_IMPORTED_MODULE_10__cube_track__["a" /* INPUT_KEYS */].priority] = 'high', _trackEvent2[__WEBPACK_IMPORTED_MODULE_10__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'CcpaData.Download', _trackEvent2));
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CcpaDataWidget.prototype.componentWillMount = function componentWillMount() {
		//Get personal data from cookies
		var cookieMap = (document.cookie || '').split(';').reduce(function (cm, kv) {
			var _kv$split = kv.split('='),
			    name = _kv$split[0],
			    value = _kv$split[1];

			cm[name.trim()] = value;
			return cm;
		}, {});

		var userData = {};

		//Add data for present personal cookies and localstorage
		[[PERSONAL_COOKIES, TYPE_COOKIE, 'cookie'], [PERSONAL_LOCAL_STORAGE, TYPE_LOCALSTORAGE, 'local storage']].forEach(function (_ref) {
			var metaArr = _ref[0],
			    storageType = _ref[1],
			    storageStr = _ref[2];

			metaArr.forEach(function (_ref2) {
				var name = _ref2[0],
				    description = _ref2[1],
				    formatterFn = _ref2[2];

				var value = storageType === TYPE_COOKIE ? cookieMap[name] : localStorage.getItem(name);
				var keyExists = storageType === TYPE_COOKIE ? name in cookieMap : value !== null;
				if (!keyExists) return; //skip missing entries
				userData[name] = {
					name: name + ' (' + storageStr + ')',
					description: description,
					type: storageType,
					source: 'User Interaction',
					status: HAS_DATA,
					value: formatterFn ? formatterFn(value) : value
				};
			});
		});

		this.setState({ userData: userData });
	};

	CcpaDataWidget.prototype.renderOriginalVersion = function renderOriginalVersion(_ref3) {
		var buttonLinks = _ref3.buttonLinks,
		    intlFields = _ref3.intlFields,
		    mockDataInjectionComponent = _ref3.mockDataInjectionComponent,
		    authenticated = _ref3.authenticated,
		    userData = _ref3.userData;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.ccpa },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'dataTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'dataDescription1', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'dataDescription2', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'dataDescription3', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'dataSoldTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'dataSoldDescription1', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'dataSoldDescription2', fields: intlFields })
			),
			this.renderUserDataSection({ mockDataInjectionComponent: mockDataInjectionComponent, authenticated: authenticated, userData: userData }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'linksTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__["a" /* CcpaButtons */], { links: buttonLinks })
		);
	};

	CcpaDataWidget.prototype.render20201123Version = function render20201123Version(_ref4) {
		var buttonLinks = _ref4.buttonLinks,
		    clientCCPALink = _ref4.clientCCPALink,
		    intlFields = _ref4.intlFields,
		    mockDataInjectionComponent = _ref4.mockDataInjectionComponent,
		    authenticated = _ref4.authenticated,
		    userData = _ref4.userData,
		    foo = _ref4.foo;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.ccpa },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.dataTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.dataDescription1', fields: intlFields }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.descriptionCoveredInteractionsWith' + (__WEBPACK_IMPORTED_MODULE_8_dlv___default()(clientCCPALink, 'url') ? '' : 'out') + 'CCPAResource', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.dataDescription2', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.dataDescription3', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.dataSoldTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.dataSoldDescription1', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.dataSoldDescription2', fields: intlFields })
			),
			this.renderUserDataSection({ mockDataInjectionComponent: mockDataInjectionComponent, authenticated: authenticated, userData: userData }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'linksTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__["a" /* CcpaButtons */], { links: buttonLinks })
		);
	};

	CcpaDataWidget.prototype.renderUserDataSection = function renderUserDataSection(_ref5) {
		var _this2 = this;

		var mockDataInjectionComponent = _ref5.mockDataInjectionComponent,
		    authenticated = _ref5.authenticated,
		    userData = _ref5.userData;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.data },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'dataUserTitle' })
			),
			mockDataInjectionComponent,
			!authenticated && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'loginToSeeData' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'dataUserDescription' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.tableContainer },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'table',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'tr',
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'th',
							null,
							'Name'
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'th',
							null,
							'Source'
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'th',
							null,
							'Status'
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'th',
							null,
							'Description'
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'th',
							null,
							'Value'
						)
					),
					Object.keys(userData).map(function (k) {
						return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'tr',
							null,
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'td',
								null,
								userData[k].name || k
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'td',
								null,
								userData[k].source
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'td',
								{ 'class': __WEBPACK_IMPORTED_MODULE_9_classnames___default()([DELETED_DATA, DELETE_FAILED].includes(userData[k].status) && __WEBPACK_IMPORTED_MODULE_2__style___default.a.deleted) },
								_this2.getStatus(k)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'td',
								null,
								userData[k].description
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'td',
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'pre',
									null,
									JSON.stringify(userData[k].value, null, 2)
								)
							)
						);
					})
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				{ href: this.getDownloadData(), download: 'my_data.tsv' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["a" /* Button */],
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.download, type: 'primary', brand: 'primary', onClick: __WEBPACK_IMPORTED_MODULE_6__os_call_with___default()(this.onDownloadClick) },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'downloadButton' })
				)
			)
		);
	};

	CcpaDataWidget.prototype.render = function render(_ref6, _ref7) {
		var links = _ref6.links,
		    clientCCPALink = _ref6.clientCCPALink,
		    clientDisplayName = _ref6.clientDisplayName,
		    mockDataInjectionComponent = _ref6.mockDataInjectionComponent,
		    overrideVersion = _ref6.overrideVersion;
		var authenticated = _ref7.authenticated,
		    userData = _ref7.userData;

		var buttonLinks = [links.main, links.partners, links.privacy],
		    hostname = window.location.hostname;
		var intlFields = { hostname: hostname, ccpaLinks: _extends({}, links, { clientCCPA: clientCCPALink }), clientDisplayName: clientDisplayName };

		return overrideVersion === '20201123' ? this.render20201123Version({ buttonLinks: buttonLinks, intlFields: intlFields, clientCCPALink: clientCCPALink, mockDataInjectionComponent: mockDataInjectionComponent, authenticated: authenticated, userData: userData }) : this.renderOriginalVersion({ buttonLinks: buttonLinks, intlFields: intlFields, mockDataInjectionComponent: mockDataInjectionComponent, authenticated: authenticated, userData: userData });
	};

	return CcpaDataWidget;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var CcpaData = Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* configure */])({
	overrideVersion: 'privacyWidgetsConfig.overrideVersion',
	links: 'privacyWidgetsConfig.ccpa.links',
	clientDisplayName: 'clientDisplayName',
	clientCCPALink: 'privacyWidgetsConfig.ccpa.links.clientCCPA' //break out separately for easier toggling/mocking of it in DEMO
})(function (props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CcpaDataWidget, props);
});

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

module.exports = {"clientDisplayName":"Aperture","privacyWidgetsConfig":{"overrideVersion":"","ccpa":{"partners":[{"text":"Amazon A9","url":"https://aps.amazon.com/aps/privacy-policy/"},{"text":"AppNexus","url":"https://www.appnexus.com/platform-privacy-policy"},{"text":"BidSwitch","url":"http://www.bidswitch.com/privacy-policy/"},{"text":"Criteo","url":"https://www.criteo.com/privacy/"},{"text":"Google","url":"https://policies.google.com/privacy?hl=en"},{"text":"Index","url":"https://www.indexexchange.com/privacy/"},{"text":"MediaMath","url":"https://www.mediamath.com/privacy-policy/"},{"text":"VerizonMedia","url":"https://www.verizonmedia.com/policies/ie/en/verizonmedia/privacy/index.html"},{"text":"OpenX","url":"https://www.openx.com/legal/privacy-policy/"},{"text":"Pubmatic","url":"https://pubmatic.com/legal/privacy/"},{"text":"RythymOne","url":"https://www.rhythmone.com/privacy-policy#jwpUwyDcbkBdaOrD.97"},{"text":"Rubicon","url":"https://rubiconproject.com/privacy/"},{"text":"Sonobi","url":"https://sonobi.com/privacy-policy/"},{"text":"Sovrn","url":"https://www.sovrn.com/privacy-policy/"},{"text":"The Trade Desk","url":"https://www.thetradedesk.com/general/privacy-policy"},{"text":"Taboola","url":"https://www.taboola.com/privacy-policy"}],"links":{"aboutOurAds":{"text":"About Our Ads","url":"/ad/about/"},"main":{"text":"Do Not Sell My Personal Information","url":"/ccpa"},"data":{"text":"Personal Data Download & Deletion","url":"/ccpa/data"},"partners":{"text":"Data Partners","url":"/ccpa/partners"},"privacy":{"text":"Privacy Page","url":"https://www.synacor.com/privacy-policy/","external":true},"clientCCPA":{"url":"","external":true}}},"gdpr":{"description":"You can still access your important information through the links below. Thank you for your patience.","links":[{"text":"iMedia","url":"https://imds.tv","icon":"location-cube"},{"text":"Email","url":"https://mail.zimbra.com/","icon":"mail-wire-cube"},{"text":"Billing","url":"https://www.synacor.com/products/start/default.aspx","icon":"billing-wire-cube"}],"copyright":"Copyright ©2022 Synacor, Inc","footerLinks":[{"text":"Privacy Policy","url":"https://www.synacor.com/privacy-policy/"},{"text":"Terms & Conditions","url":"https://www.zimbra.com/legal/support-terms/"}]},"aboutAds":{"adControls":{"enableEmailAdControl":false,"enablePortalAdControl":false}},"privacyPolicy":{"synacorLink":"https://www.synacor.com/privacy-policy/"}}}

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ccpa":"privacy_ccpa-data_ccpa","title":"privacy_ccpa-data_title","description":"privacy_ccpa-data_description","sectionTitle":"privacy_ccpa-data_sectionTitle","sectionDescription":"privacy_ccpa-data_sectionDescription","data":"privacy_ccpa-data_data","tableContainer":"privacy_ccpa-data_tableContainer","download":"privacy_ccpa-data_download","deleted":"privacy_ccpa-data_deleted"};

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"privacy_ccpa-buttons_buttons","buttonWrapper":"privacy_ccpa-buttons_buttonWrapper","button":"privacy_ccpa-buttons_button"};

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_synaff__ = __webpack_require__(583);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__lib_synaff__["a" /* default */]);

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SynAff; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dlv__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Syn */


var already_updated = false;

var Version0 = function () {
	function Version0() {
		_classCallCheck(this, Version0);

		this.init();
	}

	Version0.prototype.init = function init() {
		return { primary: null, affinities: [0, 0, 0, 0, 0] };
	};

	Version0.prototype.parse = function parse(cookie_value) {
		var matches = void 0;
		if (!(matches = /^0([0-9a-z]|X)((?:[0-9a-z]{2})+)$/.exec(cookie_value))) {
			return null;
		}
		var primary = matches[1] === 'X' ? null : parseInt(matches[1], 36);
		var affstr = matches[2];
		var affinities = [];
		for (var i = 0; i < affstr.length / 2; i++) {
			affinities[i] = parseInt(affstr.substr(i * 2, 2), 36);
		}
		return { primary: primary, affinities: affinities };
	};

	return Version0;
}();

var Version1 = function () {
	function Version1(affinities) {
		_classCallCheck(this, Version1);

		this.affinities = affinities;
	}

	Version1.prototype.init = function init() {
		var v1 = {
			primary: null,
			affinities: [],
			group: Math.random() < 0.5 ? 0 : 1,
			interval: this.interval_cur()
		};
		for (var i = 0; i < this.affinities.length; i++) {
			v1.affinities[i] = 0;
		}
		return v1;
	};

	Version1.prototype.interval_cur = function interval_cur() {
		// Weeks since 1/4/2014 7:00:00 PM
		return Math.floor((new Date().getTime() / 1000 - 1388880000) / (60 * 60 * 24 * 7));
	};

	Version1.prototype.upgrade_from_previous = function upgrade_from_previous(v0) {
		var v1 = this.init();
		var affinity_map = [0, 1, 2, 3, 4];

		if (v0.primary !== null && v0.primary < affinity_map.length) {
			v1.primary = affinity_map[v0.primary];
		}

		for (var i = 0; i < v0.affinities.length; i++) {
			var new_i = affinity_map[i];
			if (new_i === null) {
				continue;
			}
			v1.affinities[new_i] = v0.affinities[i];
		}

		return v1;
	};

	Version1.prototype.parse = function parse(cookie_value) {
		var matches = void 0;
		if (!(matches = /^1([0-9a-z]|X)([0-9a-z])([0-9a-z]{2})((?:[0-9a-z]{2})+)$/.exec(cookie_value))) {
			if (/NaN/.exec(cookie_value)) {
				cookie_value = cookie_value.replace('NaN', '00');
				matches = /^1([0-9a-z]|X)([0-9a-z])([0-9a-z]{2})((?:[0-9a-z]{2})+)$/.exec(cookie_value);
			} else {
				return null;
			}
		}
		var primary = matches[1] === 'X' ? null : parseInt(matches[1], 36);
		var group = parseInt(matches[2], 36);
		var interval = parseInt(matches[3], 36);
		var affstr = matches[4];
		var affinities = [];

		for (var i = 0; i < this.affinities.length; i++) {
			affinities[i] = parseInt(affstr.substr(i * 2, 2), 36);
			if (isNaN(affinities[i])) {
				affinities[i] = 0;
			}
		}
		return { primary: primary, group: group, interval: interval, affinities: affinities };
	};

	return Version1;
}();

var SynAff = function SynAff() {
	_classCallCheck(this, SynAff);

	this.affinity_definitions = [{
		title: 'sports',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/sports\/?|\/vendor\/espn\/|\/category\/(sports|nfl|soccer|football|hockey|basketball|golf|baseball|auto)\/|\/article\/(fox_sports|sports_illustrated|the_fumble|reuters_sports|cine_sport|oneup|golfcom|wwe|golf_digest|gamespot)/i
	}, {
		title: 'entertainment',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/(entertainment|comics)\/?|\/category\/entertainment\//i
	}, {
		title: 'general news',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/news\/?$|\/news\/(?:read\/)?category\/(?:us|news|world|politics|tech|business)\//i
	}, {
		title: 'top searches',
		valid_primary: false,
		regex: /\bcontext=topsearches\b/i
	}, {
		title: 'video',
		valid_primary: false,
		regex: /^(https?:\/\/[^/]+)?\/player\//i
	}, {
		title: 'games',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/games\/?/i
	}, {
		title: 'weather',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/weather\/?/i
	}, {
		title: 'search',
		valid_primary: false,
		regex: /^(https?:\/\/[^/]+)?\/search\/?/i
	}, {
		title: 'other',
		valid_primary: false,
		regex: /facebook.com|dpbolvw.net|youtube.com/i
	}, {
		title: 'webmail',
		valid_primary: false,
		regex: /[./](web|z|e|)?mail[./]?/i
	}, {
		title: 'finance',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/finance(?!\/category\/myportfolio)\/?|\/category\/finance\//i
	}, {
		title: 'financeportfolio',
		valid_primary: false,
		regex: /^(https?:\/\/[^/]+)?\/finance\/category\/myportfolio\/?/i
	}, {
		title: 'shopping',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/shopping\/?|amzn\.to|kqzyfj\.com|ebay\.com|jdoqocy\.com|amazon-adsystem\.com/i
	}, {
		title: 'text',
		valid_primary: false,
		regex: /\/news\/read\/article\//i
	}, {
		title: 'slideshow',
		valid_primary: false,
		regex: /^(https?:\/\/[^/]+)?\/slideshow\//i
	}, {
		title: 'lifestyle',
		valid_primary: true,
		regex: /^(https?:\/\/[^/]+)?\/lifestyle\/|\/category\/lifestyle\//i
	}];
	this.group_definitions = [{
		title: 'test'
	}, {
		title: 'control'
	}];
	this.version = [new Version0(), new Version1(this.affinity_definitions)];

	this._cookie_read = function () {
		var matches = /(?:^|;)\s*synaff\s*=\s*([^;]+)/.exec(document.cookie);
		if (matches) {
			return matches[1];
		}
		return null;
	};

	this.read = function () {
		var synaff = this._cookie_read(),
		    aff = void 0;

		if (synaff === null) {
			return null;
		}

		var version = parseInt(synaff.substr(0, 1), 36);
		if (!this.version[version] || typeof this.version[version].parse !== 'function') {
			return false;
		}
		aff = this.version[version].parse(synaff);
		if (!aff) {
			return false;
		}

		return this.upgrade(version, aff);
	};

	this.readAndLabel = function () {
		var _this = this;

		var val = this.read();
		return _extends({}, val, {
			primary: __WEBPACK_IMPORTED_MODULE_0_dlv___default()(this.affinity_definitions, val.primary + '.title'), //map to primary title
			group: __WEBPACK_IMPORTED_MODULE_0_dlv___default()(this.group_definitions, val.group + '.title'), //map to group title
			affinities: val.affinities.reduce(function (acc, curr, i) {
				//turn affinities into object from array, using indicies to find affinity group title
				acc[__WEBPACK_IMPORTED_MODULE_0_dlv___default()(_this.affinity_definitions, i + '.title')] = curr;
				return acc;
			}, {})
		});
	};

	this.upgrade = function (version_start, aff) {
		var version = version_start;
		while (this.version[version + 1] && this.version[version + 1].upgrade_from_previous) {
			aff = this.version[version + 1].upgrade_from_previous(aff);
			version++;
		}
		aff.version_start = version_start;
		aff.version = version;
		return aff;
	};

	this.update_primary = function (aff) {
		var maxi = aff.primary;
		var maxv = aff.primary === null ? 0 : aff.affinities[aff.primary];
		for (var i = 0; i < aff.affinities.length; i++) {
			if (this.affinity_definitions[i].valid_primary && aff.affinities[i] > maxv) {
				maxi = i;
				maxv = aff.affinities[i];
			}
		}
		aff.primary = maxi;
	};

	this.update_halflife = function (aff) {
		var cur_interval = this.version[this.version.length - 1].interval_cur();
		// Make sure we haven't gone back in time
		// aff.interval should be smaller than the current interval
		if (aff.interval >= cur_interval) {
			return false;
		}

		// half life for each week since we last updated interval
		while (aff.interval < cur_interval) {
			for (var i = 0; i < aff.affinities.length; i++) {
				if (aff.affinities[i] <= 2) {
					continue;
				}
				aff.affinities[i] = Math.ceil(aff.affinities[i] / 2);
			}

			aff.interval++;
		}

		return true;
	};

	this._b36_encode = function (v, bytes) {
		var str = '';
		if (v === null) {
			while (str.length < bytes) {
				str += 'X';
			}
			return str;
		}

		var max = Math.pow(36, bytes) - 1;
		str = (v > max ? max : v < 0 ? 0 : v).toString(36);
		while (str.length < bytes) {
			str = '0' + str;
		}
		return str;
	};

	this._cookie_write = function (cookie_value) {
		document.cookie = 'synaff=' + cookie_value + '; path=/; domain=' + location.hostname + '; expires=Tue, 19 Jan 2038 03:14:07 GMT';
	};

	this.write = function (aff) {
		var cv = this._b36_encode(1, 1) + this._b36_encode(aff.primary, 1) + this._b36_encode(aff.group, 1) + this._b36_encode(aff.interval, 2);
		for (var i = 0; i < aff.affinities.length; i++) {
			cv += this._b36_encode(aff.affinities[i], 2);
		}

		this._cookie_write(cv);
	};

	this.url_affinity = function (url) {
		for (var i = 0; i < this.affinity_definitions.length; i++) {
			if (url.match(this.affinity_definitions[i].regex)) {
				return i;
			}
		}
		return null;
	};

	this._already_updated = function () {
		return already_updated;
	};

	this._omniture_set = function (svalues) {
		// @TODO: Syn.Tracking.Omniture is technically a gen4 thing and may need to be changed in the future
		// Updated to also skip setting omniture if Syn.SynAff already exists, so it is only done once
		if (Syn.Tracking && Syn.Tracking.Omniture && Syn.Tracking.Omniture.setSValues && !Syn.SynAff) {
			Syn.Tracking.Omniture.setSValues(svalues);
		}
	};

	this._url_current = function () {
		return location.href;
	};

	this.update = function (url) {
		var is_init = !this._already_updated();

		// disallow multiple invocations of this function only on page render
		// outgoing traffic is allowed multiple invocations!
		if (url === null && this._already_updated()) {
			return;
		}
		already_updated = true;

		var needs_write = false;
		var aff = this.read();

		if (aff === false) {
			// don't know how to handle cookie; it's probably from the future.  abort.
			return;
		} else if (aff === null) {
			// cookie was missing or blank.  create an aff object, but don't set needs_write unless we change it later.
			aff = this.version[this.version.length - 1].init();
		} else {
			// cookie existed and was parsed.

			if (aff.version_start !== aff.version) {
				// the version was upgraded, so we should write out the new cookie.
				needs_write = true;
			}

			if (is_init) {
				if (this.update_halflife(aff)) {
					// the halflife algorithm made changes, so we should write out the new cookie.
					needs_write = true;
				}
			}
		}

		var url_affinity = this.url_affinity(url || this._url_current());
		if (url_affinity !== null) {
			aff.affinities[url_affinity]++;
			this.update_primary(aff);
			needs_write = true;
		}

		this._omniture_set({
			prop46: aff.primary === null ? '(no affinity)' : this.affinity_definitions[aff.primary] ? this.affinity_definitions[aff.primary].title : '(unknown affinity)',
			prop47: this.group_definitions[aff.group] ? this.group_definitions[aff.group].title : '(unknown group)'
		});

		if (needs_write) {
			this.write(aff);
		}
	};

	this.startup = function (config) {
		if (!config.skip_update) {
			this.update(null);
		}
	};
}

/**
 * affinity definitions
 *   title: the human-readable name of the affinity (for omniture tracking)
 *   valid_primary: whether the affinity can be marked as primary (for dcc targeting)
 *   regex: URL patterns to which this affinity applies
 *
 * @TODO: May be worth moving this into config for Cube
 *
 * IMPORTANT: Changing positions of these or deleting these is a breaking change. Additions are fine.
 */


/**
 * group definitions
 *   title: the human-readable name of the group (for omniture tracking)
 */


/**
 * Methods for handling each version of the cookie
 */


/**
 * Return the string value of the synaff cookie or null if it does not exist or is empty
 */


/**
 * Read cookie value and return aff object
 */


/**
 * Read cookie, and map affinities to their category titles instead of just using indices
 * @param {*} version_start
 * @param {*} aff
 */


/**
 * Upgrade an aff object to the latest version
 */


/**
 * Update an aff object's primary affinity
 */


/**
 * Update an aff object's interval and affinities by applying the halflife algorithm
 */


/**
 * Base-36-encode an integer ("v") into a field of the given byte width ("bytes").
 *
 * If "v" is null, returns a field of width "bytes" filled with "X".  If "v"
 * is negative, encodes 0.  If "v" is greater than the maximum value possible
 * for the field, encodes the maximum value.  The field will be padded with
 * zeroes to be of length "bytes".
 */


/**
 * Update the synaff cookie with the given value
 */


/**
 * Write aff object to cookies
 */


/**
 * Return the affinity index for the given URL
 */


/**
 * For stubbing in tests; returns the value of already_updated.
 *
 * @member Syn.Synaff
 */


/**
 * For stubbing in tests; sets a dictionary of svalues for omniture
 *
 * @member Syn.Synaff
 */


/**
 * For stubbing in tests; returns the current URL.
 */


/**
 * Read, update, and write the synaff cookie.  Can only be called once.
 *
 * @param {string} url null value for page render tracking, full url of target location if tracking external link.
 */


/**
 * Start the component.
 *
 * @param {Object} config The configuration data structure
 */
;



/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CcpaMainWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CcpaMain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cube_track__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CcpaMainWidget = (_dec = Object(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["f" /* withText */])({
	optInConfirmation: 'optInConfirmation',
	optInConfirmation20201123: '20201123.optInConfirmation'
}), _dec(_class = function (_Component) {
	_inherits(CcpaMainWidget, _Component);

	function CcpaMainWidget() {
		var _temp, _this, _ret;

		_classCallCheck(this, CcpaMainWidget);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			isOptedOut: null
		}, _this.buttonClicked = function (partnerLink) {
			if (partnerLink.external) {
				window.open(partnerLink.url, '_blank', 'noopener');
			} else {
				window.location.href = partnerLink.url;
			}
		}, _this.getIsOptedOut = function () {
			return new Promise(function (resolve) {
				return !window.__uspapi ? resolve(false) : window.__uspapi('getUSPData', 1, function (uspData) {
					return resolve(uspData && uspData.uspString && uspData.uspString.substring(2, 3) === 'Y');
				});
			});
		}, _this.toggleOptOut = function () {
			_this.getIsOptedOut().then(function (isOO) {
				var _trackEvent;

				// if trying to opt in, get confirmation
				if (isOO) {
					/* eslint-disable no-alert */
					var confirmed = confirm(_this.props['optInConfirmation' + (_this.props.overrideVersion || '')]);
					if (!confirmed) return;
				}
				//set cookie expiration for 10 years in the future
				document.cookie = 'ccpaOptOut=1Y' + (isOO ? 'N' : 'Y') + 'N; expires=' + new Date(Date.now() + 10 * 365 * 24 * 60 * 60 * 1000).toUTCString() + '; path=/';
				_this.setState({ isOptedOut: !isOO });

				Object(__WEBPACK_IMPORTED_MODULE_7__cube_track__["k" /* trackEvent */])(_this.context, (_trackEvent = {}, _trackEvent[__WEBPACK_IMPORTED_MODULE_7__cube_track__["a" /* INPUT_KEYS */].action] = 'click', _trackEvent[__WEBPACK_IMPORTED_MODULE_7__cube_track__["a" /* INPUT_KEYS */].priority] = 'high', _trackEvent[__WEBPACK_IMPORTED_MODULE_7__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'CcpaMain.OptInOrOut', _trackEvent[__WEBPACK_IMPORTED_MODULE_7__cube_track__["b" /* STANDARD_KEYS */].contenttext] = isOO ? 'In' : 'Out', _trackEvent));
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CcpaMainWidget.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		this.getIsOptedOut().then(function (isOO) {
			return _this2.setState({ isOptedOut: isOO });
		});
	};

	CcpaMainWidget.prototype.renderOriginalVersion = function renderOriginalVersion(_ref) {
		var buttonLinks = _ref.buttonLinks,
		    intlFields = _ref.intlFields,
		    isOptedOut = _ref.isOptedOut;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.ccpa },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainChoicesTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainChoicesDescription1', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainChoicesDescription2', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainCurrently' + (isOptedOut ? '' : 'Not') + 'OptedOutStatus' }),
				' -',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["a" /* Button */],
					{ type: 'floating', onClick: this.toggleOptOut },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'opt' + (isOptedOut ? 'In' : 'Out') })
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionIndentedDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainCurrentlyOptedOutDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionIndentedDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainCurrentlyNotOptedOutDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainChoicesDescription3', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionIndentedDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainChoicesDescription4', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'mainChoicesDescription5', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'mainDataAccessTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'mainDataAccessDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'linksTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__["a" /* CcpaButtons */], { links: buttonLinks })
		);
	};

	CcpaMainWidget.prototype.render20201123Version = function render20201123Version(_ref2) {
		var buttonLinks = _ref2.buttonLinks,
		    intlFields = _ref2.intlFields,
		    isOptedOut = _ref2.isOptedOut,
		    clientCCPALink = _ref2.clientCCPALink;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.ccpa },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainDescription', fields: intlFields }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.descriptionCoveredInteractionsWith' + (__WEBPACK_IMPORTED_MODULE_6_dlv___default()(clientCCPALink, 'url') ? '' : 'out') + 'CCPAResource', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCollectionAndUseTitle' })
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCollectionAndUseDescription1', fields: intlFields })
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCollectionAndUseDescription2', fields: intlFields })
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'ul',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'li',
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCollectionAndUseDescription3', fields: intlFields })
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'li',
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCollectionAndUseDescription4', fields: intlFields })
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.mainCollectionAndUseDescription5', fields: intlFields })
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainChoicesTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainChoicesDescription1', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainChoicesDescription2', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCurrently' + (isOptedOut ? '' : 'Not') + 'OptedOutStatus' }),
				' -',
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_5__cube_blocks__["a" /* Button */],
					{ type: 'floating', onClick: this.toggleOptOut },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'opt' + (isOptedOut ? 'In' : 'Out') })
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionIndentedDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCurrentlyOptedOutDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionIndentedDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainCurrentlyNotOptedOutDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainChoicesDescription3', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionIndentedDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainChoicesDescription4', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.mainChoicesDescription5', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.mainDataAccessTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionDescription },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.mainDataAccessDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.linksTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__["a" /* CcpaButtons */], { links: buttonLinks })
		);
	};

	CcpaMainWidget.prototype.render = function render(_ref3, _ref4) {
		var clientDisplayName = _ref3.clientDisplayName,
		    links = _ref3.links,
		    clientCCPALink = _ref3.clientCCPALink,
		    overrideVersion = _ref3.overrideVersion;
		var isOptedOut = _ref4.isOptedOut;

		var buttonLinks = [links.data, links.partners, links.privacy],
		    hostname = window.location.hostname;

		var intlFields = { clientDisplayName: clientDisplayName, hostname: hostname, ccpaLinks: _extends({}, links, { clientCCPA: clientCCPALink }) };

		return overrideVersion === '20201123' ? this.render20201123Version({ buttonLinks: buttonLinks, intlFields: intlFields, isOptedOut: isOptedOut, clientCCPALink: clientCCPALink }) : this.renderOriginalVersion({ buttonLinks: buttonLinks, intlFields: intlFields, isOptedOut: isOptedOut });
	};

	return CcpaMainWidget;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);

var CcpaMain = Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* configure */])({
	overrideVersion: 'privacyWidgetsConfig.overrideVersion',
	links: 'privacyWidgetsConfig.ccpa.links',
	clientCCPALink: 'privacyWidgetsConfig.ccpa.links.clientCCPA', //break out separately for easier toggling/mocking of it in DEMO
	clientDisplayName: 'clientDisplayName'
})(function (props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CcpaMainWidget, props);
});

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ccpa":"privacy_ccpa-main_ccpa","title":"privacy_ccpa-main_title","description":"privacy_ccpa-main_description","sectionTitle":"privacy_ccpa-main_sectionTitle","sectionDescription":"privacy_ccpa-main_sectionDescription","sectionIndentedDescription":"privacy_ccpa-main_sectionIndentedDescription"};

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CcpaPartnersWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CcpaPartners; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__ = __webpack_require__(385);
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CcpaPartnersWidget = function (_Component) {
	_inherits(CcpaPartnersWidget, _Component);

	function CcpaPartnersWidget() {
		var _temp, _this, _ret;

		_classCallCheck(this, CcpaPartnersWidget);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.buttonClicked = function (partnerLink) {
			if (partnerLink.external) {
				window.open(partnerLink.url, '_blank', 'noopener');
			} else {
				window.location.href = partnerLink.url;
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CcpaPartnersWidget.prototype.renderOriginalVersion = function renderOriginalVersion(_ref) {
		var partners = _ref.partners,
		    buttonLinks = _ref.buttonLinks,
		    intlFields = _ref.intlFields;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.ccpa },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'partnersTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'partnersDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.links },
				partners && partners.map(function (partner) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.link, href: partner.url, target: '_blank', rel: 'noopener noreferrer' },
						partner.text
					);
				})
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'linksTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__["a" /* CcpaButtons */], { links: buttonLinks })
		);
	};

	CcpaPartnersWidget.prototype.render20201123Version = function render20201123Version(_ref2) {
		var partners = _ref2.partners,
		    buttonLinks = _ref2.buttonLinks,
		    intlFields = _ref2.intlFields;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.ccpa },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.partnersTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.partnersDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.links },
				partners && partners.map(function (partner) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.link, href: partner.url, target: '_blank', rel: 'noopener noreferrer' },
						partner.text
					);
				})
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.partnersLiverampTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: '20201123.partnersLiverampDescription', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.sectionTitle },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: '20201123.linksTitle' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__ccpa_buttons__["a" /* CcpaButtons */], { links: buttonLinks })
		);
	};

	CcpaPartnersWidget.prototype.render = function render(_ref3, _ref4) {
		var partners = _ref3.partners,
		    links = _ref3.links,
		    clientDisplayName = _ref3.clientDisplayName,
		    overrideVersion = _ref3.overrideVersion;

		_objectDestructuringEmpty(_ref4);

		var buttonLinks = [links.main, links.data, links.privacy],
		    hostname = window.location.hostname;

		var intlFields = { hostname: hostname, ccpaLinks: links, clientDisplayName: clientDisplayName };

		return overrideVersion === '20201123' ? this.render20201123Version({ buttonLinks: buttonLinks, partners: partners, intlFields: intlFields }) : this.renderOriginalVersion({ buttonLinks: buttonLinks, partners: partners, intlFields: intlFields });
	};

	return CcpaPartnersWidget;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var CcpaPartners = Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* configure */])({
	overrideVersion: 'privacyWidgetsConfig.overrideVersion',
	partners: 'privacyWidgetsConfig.ccpa.partners',
	links: 'privacyWidgetsConfig.ccpa.links',
	clientDisplayName: 'clientDisplayName'
})(function (props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(CcpaPartnersWidget, props);
});

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ccpa":"privacy_ccpa-partners_ccpa","title":"privacy_ccpa-partners_title","description":"privacy_ccpa-partners_description","links":"privacy_ccpa-partners_links","link":"privacy_ccpa-partners_link","sectionTitle":"privacy_ccpa-partners_sectionTitle"};

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AboutOurAdsWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AboutOurAds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);





function AboutOurAdsWidget(_ref) {
	var clientDisplayName = _ref.clientDisplayName,
	    links = _ref.links,
	    adControls = _ref.adControls;

	var hostname = window.location.hostname;
	var intlFields = { hostname: hostname, ccpaLinks: links, clientDisplayName: clientDisplayName };

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.aboutAds },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'h1',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutadsTitle', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutadsDescription', fields: intlFields })
			)
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'strong',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutadsWhoPlaced', fields: intlFields })
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ul',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: '/ccpa/partners' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutadsPlacedBy', fields: intlFields })
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('p', null),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('hr', null),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'strong',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutadsWhereLearn', fields: intlFields })
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ul',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: links.privacy.url },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutadsPrivacyPractices', fields: intlFields })
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('p', null),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('hr', null),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'strong',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutAdsWhatChoices', fields: intlFields })
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutAdsWhatChoicesDesc', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ul',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'aboutAdsWhatChoicesItem1', fields: intlFields })
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: 'http://optout.networkadvertising.org/', target: '_blank', rel: 'noopener noreferrer' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutAdsWhatChoicesItem2', fields: intlFields })
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: 'http://www.networkadvertising.org/understanding-online-advertising/what-are-my-options', target: '_blank', rel: 'noopener noreferrer' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutAdsWhatChoicesItem3', fields: intlFields })
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('p', null)
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('hr', null),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'h2',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutAdsLearnMore', fields: intlFields })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'ul',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'li',
					null,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: 'http://www.networkadvertising.org/understanding-online-advertising/', target: '_blank', rel: 'noopener noreferrer' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'aboutAdsLearnMoreItem1', fields: intlFields })
					)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null)
		)
	);
}

var AboutOurAds = Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* configure */])({
	adControls: 'privacyWidgetsConfig.aboutAds.adControls',
	clientDisplayName: 'clientDisplayName',
	links: 'privacyWidgetsConfig.ccpa.links'
})(function (props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(AboutOurAdsWidget, props);
});

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"radioLabel":"privacy_about-our-ads_radioLabel","button":"privacy_about-our-ads_button","saveSuccess":"privacy_about-our-ads_saveSuccess","saveError":"privacy_about-our-ads_saveError"};

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GdprWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gdpr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_logo_widget__ = __webpack_require__(384);







function GdprWidget(_ref) {
	var description = _ref.description,
	    links = _ref.links,
	    copyright = _ref.copyright,
	    footerLinks = _ref.footerLinks;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.gdpr },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__cube_logo_widget__["a" /* default */], { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.logo, theme: 'light', size: 'lg', link: false }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'gdprTitle' })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			description
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.links },
			links && links.map(function (link) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.linkWrapper },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.link, href: link.url },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.linkContent },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__cube_blocks__["i" /* Icon */], { name: link.icon, 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.icon }),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.label },
								link.text
							)
						)
					)
				);
			})
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.footer },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.copyright },
				copyright
			),
			footerLinks && footerLinks.map(function (footerLink) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'a',
					{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.footerLink, href: footerLink.url },
					footerLink.text
				);
			})
		)
	);
}

var Gdpr = Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* configure */])({
	description: 'privacyWidgetsConfig.gdpr.description',
	links: 'privacyWidgetsConfig.gdpr.links',
	copyright: 'privacyWidgetsConfig.gdpr.copyright',
	footerLinks: 'privacyWidgetsConfig.gdpr.footerLinks'
})(function (props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(GdprWidget, props);
});

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gdpr":"privacy_gdpr_x","logo":"privacy_gdpr_logo","title":"privacy_gdpr_title","description":"privacy_gdpr_description","links":"privacy_gdpr_links","linkWrapper":"privacy_gdpr_linkWrapper","link":"privacy_gdpr_link","linkContent":"privacy_gdpr_linkContent","icon":"privacy_gdpr_icon","label":"privacy_gdpr_label","footer":"privacy_gdpr_footer","copyright":"privacy_gdpr_copyright","footerLink":"privacy_gdpr_footerLink"};

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PrivacyPolicyWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrivacyPolicy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_i18n__ = __webpack_require__(9);





function PrivacyPolicyWidget(_ref) {
	var partners = _ref.partners,
	    clientDisplayName = _ref.clientDisplayName,
	    synacorLink = _ref.synacorLink,
	    clientLink = _ref.clientLink;


	var intlFields = {
		hostname: window.location.hostname,
		clientDisplayName: clientDisplayName,
		synacorLink: synacorLink,
		clientLink: clientLink
	};

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.privacy },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["d" /* Text */], { id: 'privacyTitle' })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacyUserPrivacy', fields: intlFields })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacyManaged', fields: intlFields })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacySharing', fields: intlFields })
		),
		clientLink && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacyClientPolicy', fields: intlFields })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacySynacorPolicy', fields: intlFields })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacyDataPartners', fields: intlFields })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacyDoNotSell', fields: intlFields })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacyAboutOurAds', fields: intlFields })
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.description },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3_preact_i18n__["c" /* MarkupText */], { id: 'privacyDataDownload', fields: intlFields })
		)
	);
}

var PrivacyPolicy = Object(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* configure */])({
	clientDisplayName: 'clientDisplayName',
	synacorLink: 'privacyWidgetsConfig.privacyPolicy.synacorLink',
	clientLink: 'privacyWidgetsConfig.privacyPolicy.clientLink'
})(function (props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(PrivacyPolicyWidget, props);
});

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"privacy":"privacy_privacy-policy_privacy","title":"privacy_privacy-policy_title","description":"privacy_privacy-policy_description"};

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports = {"privacy-widgets":{"20201123":{"mainTitle":"California Consumer Privacy Act Information","mainDescription":"If you are a current California resident, the California Consumer Privacy Act (\"CCPA\") gives you the right to request that {{hostname}} provide access to the personal information we hold about you, delete your personal information, and restrict processing of your personal information.","descriptionCoveredInteractionsWithCCPAResource":"  This page covers your interactions with {{hostname}}.  For information regarding your broader interactions with {{clientDisplayName}} outside of {{hostname}}, see our <a href=\"{{ccpaLinks.privacy.url}}\">Privacy Policy</a> and <a href=\"{{ccpaLinks.clientCCPA.url}}\">{{clientDisplayName}}'s CCPA Resource Page.","descriptionCoveredInteractionsWithoutCCPAResource":"  This page covers your interactions with {{hostname}}.  For information regarding your broader interactions with {{clientDisplayName}} outside of {{hostname}}, see our <a href=\"{{ccpaLinks.privacy.url}}\">Privacy Policy</a>.","mainCollectionAndUseTitle":"Collection and Use","mainCollectionAndUseDescription1":"Information is automatically collected when you interact with {{hostname}}. Like other web-based services, this information is collected through cookies and other technologies. Information collected includes device and operating system information; IP address; web pages accessed; when the site was accessed; general location information (e.g., city and state); and preferences gathered by user input.","mainCollectionAndUseDescription2":"The information collected is used:","mainCollectionAndUseDescription3":"To tailor the content and information displayed to personalize your experiences while using the {{hostname}} site.","mainCollectionAndUseDescription4":"For analytical and security purposes such as analyzing usage patterns to improve the experience and prevent fraud and abuse.","mainCollectionAndUseDescription5":"Several companies provide analytical and advertising services via the {{hostname}} site (i.e., \"Data Partners\").  Those Data Partners may also collect information directly from you when you interact with the {{hostname}} site. If you would like to learn more, please see their privacy policies linked on the <a href=\"{{ccpaLinks.partners.url}}\">{{ccpaLinks.partners.text}}</a> page.","mainChoicesTitle":"User Choices and Opting Out","mainChoicesDescription1":"You have the following options for controlling the interest-based content and ads you receive on {{hostname}}.","mainChoicesDescription2":"If you do not want to receive interest-based ads on {{hostname}}, you can disable the display of such ads by clicking on the opt-out button below. Please note that an opt out will not prevent you from seeing advertisements on {{hostname}}. Rather, the opt out will prevent {{hostname}}, our data partners, and third-parties from using your information to tailor the advertisements to your interests. You will continue to receive advertisements that are selected based on the particular page that you are viewing (i.e., contextually based ads).","mainCurrentlyNotOptedOutStatus":"You are currently: Not Opted Out","mainCurrentlyOptedOutStatus":"You are currently: Opted Out","mainCurrentlyNotOptedOutDescription":"Not Opted Out: Our partners and third-parties may use your personal information to serve you personalized content and advertisements.","mainCurrentlyOptedOutDescription":"Opted Out: You have opted out of the sale of your personal information.  Our partners and third-parties may not use your personal information to serve you personalized content and advertisements.","mainChoicesDescription3":"Because the {{hostname}} opt-out tracking mechanisms operate at the device and browser level, to fully opt-out across devices, you will need to do so on each device and browser individually.","mainChoicesDescription4":"If your browsers are configured to reject cookies, your opt-out may not be effective, since {{hostname}} identifies your choice to opt-out based on an opt-out cookie. In this case, you will need to confirm that your browser is configured properly in order for the opt-out to be effective. If you are using a Safari browser on iOS11 or macOS High Sierra, you must first adjust your Privacy and Security Settings to turn off both “Prevent Cross-Site Tracking” and “Block All Cookies”, and then return to this privacy policy or your preferred opt out platform to reset your opt out preferences.","mainChoicesDescription5":"You may also visit the privacy policy pages of {{hostname}}'s <a href=\"{{ccpaLinks.partners.url}}\">{{ccpaLinks.partners.text}}</a> to opt out at an individual partner level.  By opting-out with each Data Partner, those opt-outs will operate not only on {{hostname}} but also on other websites where those Data Partners are present.  Our <a href=\"{{ccpaLinks.aboutOurAds.url}}\">{{ccpaLinks.aboutOurAds.text}}</a> page provides more information about interest-based advertising and industry-wide measure you can take to set your opt-out choices.","mainDataAccessTitle":"Data Access and Deletion","mainDataAccessDescription":"See the <a href=\"{{ccpaLinks.data.url}}\">{{ccpaLinks.data.text}}</a> page to access and delete personal information that {{hostname}} holds.","optOut":"Opt Out","optIn":"Opt In","optInConfirmation":"Are you sure you want to opt-in to the sale of your personal information?","linksTitle":"Links","partnersTitle":"Data Partners","partnersDescription":"{{hostname}} has partnered with the following ad networks, data providers, and service providers to provide content and advertisements, or measure traffic as described in the <a href=\"{{ccpaLinks.data.url}}\">{{ccpaLinks.data.text}}</a> page. Please use the links provided below to read their privacy policies, use their data access and deletion tools, or use their opt-out tools. Please also note that, while this list is constantly updated, we do not guarantee that it is fully up-to-date.","partnersLiverampTitle":"LiveRamp","partnersLiverampDescription":"When you use {{hostname}}, {{clientDisplayName}} shares information that it collects from you, such as your email (in hashed form), IP address or information about your browser or operating system, with identity partners/service providers, including LiveRamp Inc. (\"LiveRamp\"). LiveRamp returns an online identification code that may be stored in a first-party cookie for use in online and cross-channel advertising and it may be shared with advertising companies to enable interest-based and targeted advertising. To opt out of this use, please click here (<a href=\"https://optout.liveramp.com/opt_out\">https://optout.liveramp.com/opt_out</a>).","dataTitle":"Data Access & Deletion","dataDescription1":"This policy outlines what personal information {{hostname}} holds about you and how you can access or delete your personal information.","dataDescription2":"You have the right to request that {{hostname}} provide you with access to the personal information we hold about you, delete your personal information, and restrict processing of your personal information. For more information about how we collect, use, and disclose information that we obtain through {{hostname}}, please see <a href=\"{{ccpaLinks.main.url}}\">{{ccpaLinks.main.text}}</a>.","dataDescription3":"See our <a href=\"{{ccpaLinks.partners.url}}\">{{ccpaLinks.partners.text}}</a> page to access and delete personal information that they may hold about you.","dataSoldTitle":"Sold Data","dataSoldDescription1":"In the past 12 months, {{hostname}} has not sold any data that we have collected. However, we work with several Data Partners to place their code on {{hostname}} which permits them to collect personal information in order to display advertisements and content based on your visits to this website and other websites that you have visited in the past. This may constitute a sale of personal information under CCPA.","dataSoldDescription2":"To restrict the collection and use of your personal information by our Data Partners while you are on {{hostname}}, see the Do Not Sell My Personal Information page. The collection, use, and sale of your personal information collected by our Data Partners is also governed by each Data Partner’s specific privacy policy. Please see the privacy policy links of our <a href=\"{{ccpaLinks.partners.url}}\">{{ccpaLinks.partners.text}}</a> for more information.","dataUserTitle":"User Data","loginToSeeData":"If you have an account, login to see additional data associated with your logged-in state.","dataUserDescription":"This table shows the Name of the data/collection of data, the source of that data, and provides the ability to delete the data.  Click the “Download User Data” button below to download the data in a portable TSV document.","statusChecking":"Checking for data ...","statusNoData":"No stored data","statusDeleting":"Deleting data ...","statusDeleted":"Data deleted","statusFailed":"Data deletion failed","statusDeleteButton":"Delete Data","downloadButton":"Download User Data","gdprTitle":"We are working to enhance your experience!","adControlsHeader":"{{clientDisplayName}} Ad Controls","adControlsDescription1":"We realize that some {{clientDisplayName}} customers may not want to see third-party advertisements.","adControlsDescription2":"If you are not interested in seeing offers from other companies, just select the OFF option and click on the Save button.","signInForAdPref":"Please sign in to manage your ad preferences:","signIn":"Sign In","emailAdsHeader":"Ads in {{clientDisplayName}} Email","emailAdsOn":"<strong>By choosing \"ON\"</strong>, third-party ads will appear on the right hand side of the page when viewing your email online.","emailAdsOff":"<strong>By choosing \"OFF\"</strong>, third-party ads will NOT appear on the right hand side of the page when viewing your email online. This does not affect any individual email messages you receive.","portalAdsHeader":"Ads on the {{clientDisplayName}} Portal","portalAdsOn":"<strong>By choosing \"ON\"</strong>, third-party ads will appear on the portal.","portalAdsOff":"<strong>By choosing \"OFF\"</strong>, third-party ads will NOT appear on the portal.","adControlsSaved":"Ad Control settings were successfully saved","adControlsSaveError":"There was an error saving the Ad Control settings"},"aboutadsTitle":"Advertising Information","aboutadsDescription":"The web sites you visit work with online advertising companies to provide you with advertising that is as relevant and useful as possible. Some of the online ads you are served may be based on the content of the Web page you're visiting; some others may be based on information you provide; and other ads may be customized based on predictions about your interests generated from your visits to the other websites.","aboutadsWhoPlaced":"Who placed this ad?","aboutadsPlacedBy":"This ad was placed by one of {{hostname}}’s advertising partners","aboutadsWhereLearn":"Where can I learn more about {{clientDisplayName}}'s privacy practices related to advertising?","aboutadsPrivacyPractices":"Please read about {{clientDisplayName}}'s privacy and advertising practices.","aboutAdsWhatChoices":"What choices do I have about interest-based advertising?","aboutAdsWhatChoicesDesc":"Information about your visits to this and other sites may be used over time to help predict your interests and select the ads you see.","aboutAdsWhatChoicesItem1":"Visit our <a href=\"{{ccpaLinks.main.url}}\">{{ccpaLinks.main.text}}</a> page to opt-out of the sale of personal data, including interest-based advertising on {{hostname}}.","aboutAdsWhatChoicesItem2":"Visit the Network Advertising Initiative to learn more about online behavioral advertising and to see your opt-out choices from other participating companies.","aboutAdsWhatChoicesItem3":"Explore other controls and tools to help set and maintain your privacy choices.","aboutAdsLearnMore":"Learn More","aboutAdsLearnMoreItem1":"Learn more about online advertising from the Network Advertising Initiative.","mainTitle":"California Consumer Privacy Act Information","mainDescription":"You have the right to request that {{hostname}} provide you with access to the personal data we hold about you, delete your personal data, and restrict processing of your personal data. For more information about how we collect, use, and disclose information that we obtain through our website, please see our Privacy Policy.","mainChoicesTitle":"User Choices and Opting Out","mainChoicesDescription1":"{{hostname}} supports initiatives to offer our Users greater transparency and control over the uses of their Information. Therefore, we offer the following options for controlling the interest-based content and ads you receive.","mainChoicesDescription2":"If you do not want to receive interest-based ads from {{hostname}}, you can disable the display of such ads by clicking on the opt-out button below. Please note that an opt out will not prevent you from seeing advertisements on {{hostname}}. Rather, the opt out will prevent {{hostname}}, our data partners, and third-parties from using your Information to tailor the advertisements to your interests. You will continue to receive advertisements that are selected based on the particular page that you are viewing (i.e. contextually based ads).","mainCurrentlyNotOptedOutStatus":"You are currently: Not Opted Out","mainCurrentlyOptedOutStatus":"You are currently: Opted Out","mainCurrentlyNotOptedOutDescription":"Not Opted Out: {{hostname}} will instruct our partners and third-parties that they may use your personal data to serve you personalized content and advertisements.","mainCurrentlyOptedOutDescription":"Opted Out: You have opted out of the sale of your personal data, {{hostname}} will instruct our partners and third-parties that they may not use your personal data to serve you personalized content and advertisements.","mainChoicesDescription3":"Because our tracking mechanisms operate at the device and browser level, to fully opt-out across devices, you will need to do so on each device and browser individually.","mainChoicesDescription4":"If your browsers are configured to reject cookies, your opt-out may not be effective, since we identify your choice to opt-out based on an opt-out cookie we deliver to you. In this case, you will need to confirm that your browser is configured properly in order for the opt-out to be effective. If you are using a Safari browser on iOS11 or macOS High Sierra, you must first adjust your Privacy and Security Settings to turn off both “Prevent Cross-Site Tracking” and “Block All Cookies”, and then return to this privacy policy or your preferred opt out platform to reset your opt out preferences. ","mainChoicesDescription5":"You may also visit the privacy policy pages of our <a href=\"{{ccpaLinks.partners.url}}\">{{ccpaLinks.partners.text}}</a> to opt out at an individual partner level.  Our <a href=\"{{ccpaLinks.aboutOurAds.url}}\">{{ccpaLinks.aboutOurAds.text}}</a> page provides more information about interest-based advertising and industry-wide measure you can take to set your opt-out choices.","mainDataAccessTitle":"Data Access and Deletion","mainDataAccessDescription":"See the <a href=\"{{ccpaLinks.data.url}}\">{{ccpaLinks.data.text}}</a> page to access and delete personal data that {{hostname}} holds.","optOut":"Opt Out","optIn":"Opt In","optInConfirmation":"Are you sure you want to opt-in to the sale of your personal data?","linksTitle":"Links","partnersTitle":"Data Partners","partnersDescription":"{{hostname}} has partnered with the following third party partners, ad networks, data providers, and service providers to provide content and advertisements, or measure traffic all as part of the Taboola Services. Please also note that, while this list is constantly updated, we do not guarantee that it is fully up-to-date.","dataTitle":"Data Access & Deletion","dataDescription1":"This policy outlines what personal data information {{hostname}} holds about you and how you can access or delete your personal data.","dataDescription2":"You have the right to request that {{hostname}} provide you with access to the personal data we hold about you, delete your personal data, and restrict processing of your personal data. For more information about how we collect, use, and disclose information that we obtain through our website, please see our Privacy Policy.","dataDescription3":"See our <a href=\"{{ccpaLinks.partners.url}}\">{{ccpaLinks.partners.text}}</a> page to access and delete personal data that they may hold about you.","dataSoldTitle":"Sold Data","dataSoldDescription1":"In the past 12 months we have not sold any data that we have collected.  To restrict the processing of your data by {{hostname}}, see the <a href=\"{{ccpaLinks.main.url}}\">{{ccpaLinks.main.text}}</a> page.","dataSoldDescription2":"{{hostname}} does not “sell” any personal data of Users, meaning that we do not collect and transfer to a third-party personal data for any valuable consideration.  {{hostname}} does however work with several partners that have their third-party code on {{hostname}}.  These third parties display advertisements based on your visits to this website and other websites that you have visited in the past.  The collection and use of your personal data is governed by each third party’s specific privacy policy.  Please see the privacy policy links of our <a href=\"{{ccpaLinks.partners.url}}\">{{ccpaLinks.partners.text}}</a> for more information.","dataUserTitle":"User Data","loginToSeeData":"If you have an account, login to see additional data associated with your logged-in state.","dataUserDescription":"This table shows the Name of the data/collection of data, the source of that data, and provides the ability to delete the data.  Click the “Download User Data” button below to download the data in a portable TSV document.","statusChecking":"Checking for data ...","statusNoData":"No stored data","statusDeleting":"Deleting data ...","statusDeleted":"Data deleted","statusFailed":"Data deletion failed","statusDeleteButton":"Delete Data","downloadButton":"Download User Data","gdprTitle":"We are working to enhance your experience!","privacyTitle":"Privacy","privacyUserPrivacy":"User privacy is important to {{clientDisplayName}}. This page is to give you information about how your information is used and the options available to you when you visit {{hostname}}.","privacyManaged":"{{hostname}} is managed by Synacor, Inc. (\"Synacor\") on behalf of {{clientDisplayName}}.","privacySharing":"When you visit and interact with {{hostname}}, {{clientDisplayName}} shares your information with Synacor and its Data Partners in order to provide the services and content available at {{hostname}}.","privacyClientPolicy":"To view {{clientDisplayName}}'s Privacy Policy, click <a href=\"{{clientLink}}\">here</a>.","privacySynacorPolicy":"To view Synacor's Privacy Policy, click <a href=\"{{synacorLink}}\">here</a>.","privacyDataPartners":"Additional information about the Data Partners and how to limit sharing of personal data with them is available <a href=\"/ccpa/partners\">here</a>.","privacyDoNotSell":"The <a href=\"/ccpa\">Do Not Sell</a> page allows you to restrict sharing of your information for interest-based ads. It also provides information to California-based users about rights available under the California Consumer Protection Act.","privacyAboutOurAds":"For more information about advertising served on {{hostname}}, click <a href=\"/ad/about\">About Our Ads</a>.","privacyDataDownload":"See the <a href=\"/ccpa/data\">Personal Data Download & Deletion</a> page to access and delete personal data that {{clientDisplayName}} holds."}}

/***/ })

});


// WEBPACK FOOTER //
// widgets/privacy.6302172c.chunk.js